import React from 'react';
// Корпус — как у уведомления о несостоявшемся поиске рейтингового матча:
// тот же случай «нажал кнопку матча в меню, а войти не вышло»
import '../RankMatchSearchNoticeModal/RankMatchSearchNoticeModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {TEXT_AI_MATCH_JOIN_ERROR_TITLE} from '../../../constants/text/aiMatch';

const PAGE_ID = 'AiMatchJoinErrorModal';

/**
 * Отказ входа в лобби «Битвы с AI Claude Opus» из главного меню (кнопка или
 * промо-модалка). Не тост: тосты рисуются только на экране матча (Toast живет
 * в GameContent), а игрок после отказа остается в меню. Текст — из
 * getAiLobbyJoinErrorText.
 *
 * @param {string} text
 * @param {Function} onHide
 */
function AiMatchJoinErrorModal({text, onHide}) {
  return (
    <div className="rank-match-search-notice-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="rank-match-search-notice-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="rank-match-search-notice-title">{TEXT_AI_MATCH_JOIN_ERROR_TITLE}</h2>
        <p className="rank-match-search-notice-text">{text}</p>
        <div className="main-menu-buttons rank-match-search-notice-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Скрыть
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default AiMatchJoinErrorModal;
